import React from 'react';
import { motion } from 'framer-motion';
import Container from '../../layout/Container';
import SectionHeading from '../../common/SectionHeading';

const EnabledServices = () => {
  return (
    <section className="pt-24 pb-16 bg-white">
      <Container>
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <SectionHeading
              title="Enabling IT Services"
              subtitle="Comprehensive IT solutions tailored to meet your business needs."
              center
            />
            
            <div className="mt-8 bg-blue-50 p-8 rounded-lg">
              <p className="text-gray-700 leading-relaxed">
                In today's rapidly evolving digital landscape, businesses require robust IT infrastructure to remain 
                competitive and efficient. At Bytematic IT Solutions, we understand the unique challenges that 
                organizations face when it comes to implementing and maintaining effective IT systems. Our enabling 
                IT services are designed to empower your business with the technology and support needed to 
                thrive in the modern marketplace.
              </p>
              
              <p className="text-gray-700 leading-relaxed mt-4">
                Whether you're a small startup looking to establish your IT foundation or a large enterprise 
                seeking to optimize your existing infrastructure, our team of experts is here to guide you through 
                every step of the process. We take a client-centered approach, focusing on understanding your 
                specific requirements and delivering solutions that align with your business objectives and budget.
              </p>
            </div>
          </motion.div>
          
          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md border border-gray-100"
            >
              <h3 className="text-xl font-bold mb-4 text-blue-700">Business-Focused Solutions</h3>
              <p className="text-gray-600">
                We recognize that technology should serve your business goals, not the other way around. 
                Our solutions are designed with your specific industry requirements, operational needs, 
                and growth objectives in mind. By aligning IT with your business strategy, we help you 
                leverage technology as a competitive advantage.
              </p>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md border border-gray-100"
            >
              <h3 className="text-xl font-bold mb-4 text-blue-700">End-to-End Support</h3>
              <p className="text-gray-600">
                From initial consultation and planning to implementation, maintenance, and ongoing 
                support, we provide comprehensive services that cover the entire IT lifecycle. Our 
                approach ensures that you have a reliable partner at every stage, capable of addressing 
                challenges and identifying opportunities for improvement.
              </p>
            </motion.div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default EnabledServices;